import React from 'react';
import PropTypes from 'prop-types';

import MetaTags from '~/components/MetaTags/MetaTags';
import Layout from '~/components/Layout/Layout';
import RelatedNewsRiver from '~/components/RelatedNewsRiver/RelatedNewsRiver';
import { initStore } from '~/state/store';
import { bindActionCreators } from 'redux';

import { operations } from '~/state/pageData';
import matchupOperations from '~/state/matchup/operations';
import { selectMatchup } from '~/state/matchup/reducers';

import { getMatchupArticle } from '~/util/getContent';
import logEvent from '~/util/analytics';
import withState from '~/hocs/withState';
import MatchupArticleComponent from '~/components/MatchupArticle/MatchupArticle';
import MatchupMenu from '~/components/MatchupMenu/MatchupMenu';

class MatchupArticle extends React.Component {
  static async getInitialProps(props) {
    let article = null;
    if (props.leagueSlug) {
      const eventId = String(selectMatchup(props.store.getState()).data.id) || '';

      if (eventId !== props.query.eventId) {
        const eventResult = await props.store.dispatch(
          matchupOperations.fetchMatchup(props.leagueSlug, props.query.eventId)
        );

        if (eventResult.result === 'FAILURE') {
          //eslint-disable-next-line
          props.res.statusCode = eventResult.statusCode;
          return {
            article: {},
            subSection: props.query.subSection,
          };
        }
      }

      if (selectMatchup(props.store.getState()).data) {
        article = await getMatchupArticle(selectMatchup(props.store.getState()).data);
      }

      if (article && article.id) {
        props.store.dispatch(operations.setAdConfig(article, 'article'));
      }
    }

    if (!article || !article.id) {
      // eslint-disable-next-line
      props.res.statusCode = 404;
    }

    return {
      article,
      subSection: props.query.subSection,
      leagueSlug: props.leagueSlug,
    };
  }

  componentDidMount() {
    const event = this.props.event.data;
    logEvent('page_view', {
      league: this.props.leagueSlug,
      page_type: 'matchup_article',
      article_id: this.props.article.id,
    });

    this.props.loadRelatedNews({
      relatedUri: event.resource_uri,
      relatedNews: { before: null, relatedContent: [] },
    });
  }

  render() {
    const event = this.props.event.data;
    const isFinal = event.event_status === 'final';

    return (
      <Layout>
        <MetaTags content={event} type={isFinal ? 'matchup_recap' : 'matchup_preview'} />
        <div style={{ padding: 10 }}>
          <MatchupMenu event={event} currentSection={this.props.subSection} />
        </div>
        <MatchupArticleComponent article={this.props.article} event={event} />
        <RelatedNewsRiver resourceUri={event.related_uri} />
      </Layout>
    );
  }
}

MatchupArticle.propTypes = {
  leagueSlug: PropTypes.string.isRequired,
  event: PropTypes.shape({
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
  }).isRequired,
  article: PropTypes.object.isRequired,
  subSection: PropTypes.string.isRequired,
  loadRelatedNews: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  event: selectMatchup(state),
});

const mapDispatchToProps = dispatch => ({
  loadRelatedNews: bindActionCreators(operations.loadRelatedNews, dispatch),
});

MatchupArticle.displayName = 'MatchupArticlePage';

export default withState({ createStore: initStore, mapStateToProps, mapDispatchToProps })(
  MatchupArticle
);
